<template>
  <div> 
    <nav-bar/>
      <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow">
        <ul class="nav flex-column">
            <li class="nav-item" id="current">
              <a class="nav-link navbar-text" href="#/TransferPending">
                {{$t('TransferPending.sidebar.pending')}}
              </a>
              <span v-if="transfers.length > 0" class="pull-right badge badge-default">{{ transfers.length }}</span>
            </li>
            <li class="nav-item">
              <a class="nav-link navbar-text" href="#/TransferCurrent">
                {{$t('TransferPending.sidebar.completed')}}
              </a>
            </li>
        </ul>
      </div>
    <div class="view">
      <div class="card">
        <div class="card-header">
          <h3 class="my-2">{{$t('TransferPending.title')}}</h3>
        </div>
        <paginate name="filterResults" tag="div" :list="filterResults" class="" :per="40">
          <div class="table-responsive">
            <table class="table table-hover font-grey mb-0 table-sm">
              <thead class="bg-darkgrey">
                <tr>
                  <th @click="sortBy('.key', false)" class="sortable nowrap">{{$t('TransferPending.order')}}<i v-if="sort.current === '.key'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('vin', false)" class="sortable nowrap">{{$t('TransferPending.VIN')}}<i v-if="sort.current === 'vin'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('creationDate', false)" class="sortable nowrap">{{$t('TransferPending.date')}}<i v-if="sort.current === 'creationDate'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('transmitterName', false)" class="sortable nowrap">{{$t('TransferPending.pickup')}}<i v-if="sort.current === 'transmitterName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('receiverName', false)" class="sortable nowrap">{{$t('TransferPending.delivery')}}<i v-if="sort.current === 'receiverName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('nameTransfered', false)" class="sortable nowrap">{{$t('TransferPending.carrier')}}<i v-if="sort.current === 'nameTransfered'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                </tr>
              </thead>
              <transition-group name="fade" tag="tbody">
                <tr key='filter'>
                  <td>
                    <regular-input
                      :value="fields['.key']"
                      @input="fields['.key'] = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferPending.order')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.vin"
                      @input="fields.vin = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferPending.VIN')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.creationDate"
                      @input="fields.creationDate = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferPending.date')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.transmitterName"
                      @input="fields.transmitterName = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferPending.pickup')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.receiverName"
                      @input="fields.receiverName = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferPending.delivery')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.nameTransfered"
                      @input="fields.nameTransfered = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferPending.carrier')"/>
                  </td>
                </tr>
                <tr v-for="transfer in paginated('filterResults')" :key="transfer['.key']">
                  <td class="nowrap">{{transfer['.key']}}</td>
                  <td class="nowrap">{{transfer.vin}}</td>
                  <td class="nowrap">{{getDate(transfer.creationDate)}}</td>
                  <td class="nowrap"><p class="table-fix-width">{{transfer.transmitterName}}</p></td>
                  <td class="nowrap"><p class="table-fix-width">{{transfer.receiverName}}</p></td>
                  <td class="nowrap">{{transfer.nameTransfered}}</td>
                </tr>
              </transition-group>
            </table>
          </div>
        </paginate>
        <paginate-links for="filterResults" :hide-single-page="true" :limit="5"></paginate-links>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../Modal.vue'
import regularInput from '../regularInput.vue'
import regularCheckbox from '../regularCheckbox.vue'
import regularTextarea from '../regularTextarea.vue'
import Search from '../module/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'

export default {
  name: 'transferPending',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    Search
  },
  data () {
    return {
      closedModal: true,
      fields: {
        '.key': '',
        vin: '',
        creationDate: '',
        transmitterName: '',
        receiverName: '',
        nameTransfered: ''
      },
      filterResults: [],
      transfers: [],
      paginate: ['filterResults'],
      sort: {
        current: '.key',
        desc: true
      }
    }
  },
  methods: {
    filteredSearchMethod: _.debounce(function () {
      this.filterResults = []
      this.filterResults = this.transfers.filter((entry) => {
        var result = true
        for (var attr in this.fields) {
          if (this.fields[attr] !== '') {
            var reg = this.fields[attr].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            var re = new RegExp(reg, 'i')
            if (attr === 'creationDate') {
              let date = this.getDate(entry[attr])
              result = re.test(date)
            } else if (attr === 'status') {
              if (entry.status === 'Dispatch') result = re.test(this.$t('Search.status.dispatch'))
              else if (entry.status === 'Pick') result = re.test(this.$t('Search.status.pick'))
              else if (entry.status === 'Processing') result = re.test(this.$t('Search.status.processing'))
              else if (entry.status === 'Waiting') result = re.test(this.$t('Search.status.waiting'))
              else if (entry.status === 'Transit') result = re.test(this.$t('Search.status.transit'))
              else if (entry.status === 'Drop') result = re.test(this.$t('Search.status.drop'))
              else if (entry.status === 'Cancel') result = re.test(this.$t('Search.status.canceled'))
              else if (entry.status === 'Terminée') result = re.test(this.$t('Search.status.finished'))
              else if (entry.status === 'Transférée') result = re.test(this.$t('Search.status.transfered'))
              else if (entry.status === 'Reject') result = re.test(this.$t('Search.status.rejected'))
              else result = false
            } else {
              result = re.test(entry[attr])
            }
          }
          if (result === false) break
        }
        return result
      })
      this.filterResults.reverse()
      this.sortBy(this.sort.current, true)
    }, 100),
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString()
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.filterResults.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'creationDate' && criteria !== '.key') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        } else {
          A = parseInt(a[criteria])
          B = parseInt(b[criteria])
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    }
  },
  created () {
    this.$bindAsArray('transfers', db.ref('test/transporter/' + this.companyUID + '/pendingTransfer'), null, () => {
      this.filteredSearchMethod()
    })
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// TransferPending.vue?eed97e3c